import { gql } from "@apollo/client";

export const GET_ALL_QUIZZES = gql`
  query quiz_schemas {
    QUIZ_schemas {
      id
      title
      description
      image_url
      priority
    }
  }
`;

export const START_QUIZZ = gql`
  mutation start_quiz($schema_id: Int!) {
    start_quiz(schema_id: $schema_id) {
      id
      access_token
      score
      schema {
        id
        title
        description
        image_url
        problems {
          id
          body
          hint
          solution
          options {
            id
            body
            is_solution
          }
          select_count
        }
      }
    }
  }
`;

export const END_QUIZ = gql`
  mutation end_quiz($quiz_id: Int!) {
    end_quiz(quiz_id: $quiz_id) {
      id
      access_token
      score
      schema {
        id
        title
        description
        image_url
        problems {
          id
          body
          hint
          solution
          options {
            id
            body
            is_solution
          }
          select_count
        }
      }
    }
  }
`;

export const GET_QUIZ_WITHOUT_RESULT = gql`
  query get_quiz($id: ID!) {
    QUIZ_quiz(id: $id) {
      id
      access_token
      score
      answers
      schema {
        id
        title
        description
        image_url
        problems {
          id
          body
          hint
          solution
          options {
            id
            body
            is_solution
          }
          select_count
        }
      }
    }
  }
`;

export const GET_QUIZ_WITH_RESULT = gql`
  query get_quiz($quiz_id: Int!) {
    get_quiz(quiz_id: $quiz_id) {
      id
      access_token
      result
      score
      answers
      schema {
        id
        title
        description
        image_url
        problems {
          id
          body
          hint
          solution
          options {
            id
            body
            is_solution
          }
          select_count
        }
      }
    }
  }
`;

export const AVG_SCHEMA_SCORE = gql`
  query QUIZ_average_score($schema_id: Int!) {
    QUIZ_average_score(schema_id: $schema_id)
  }
`;
